import React from 'react';
import PropTypes from 'prop-types';

const CapsLockContext = React.createContext(false);

export const CapsLockConsumer = CapsLockContext.Consumer;

export const CapsLockProvider = ({ children }) => {
  const [capsLockOn, setCapsLockOn] = React.useState(false);
  
  React.useEffect(() => {
    const callback = (event) => {
      const eventCapsLockClicked = event.code === 'CapsLock' || event.key === 'CapsLock' || event.keyCode === 20;
      const eventCapsLock = Boolean(event.getModifierState && event.getModifierState('CapsLock'));
      setCapsLockOn(oldCapsLockOn => eventCapsLockClicked && oldCapsLockOn ? false : eventCapsLock);
    };
    window.addEventListener('keyup', callback);
    //window.dispatchEvent(new KeyboardEvent("keyup")); // dummy event does not provide real keyboard meta state
    return () => window.removeEventListener('keyup', callback);
  }, []);
  
  return (
    <CapsLockContext.Provider value={capsLockOn}>
      {children}
    </CapsLockContext.Provider>
  );
};

CapsLockProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
};

export const withCapsLockListener = (Component) => {
  if (CapsLockConsumer !== undefined && Component !== undefined) {
    const wrapper = ({ ...componentProps }) => (
      <CapsLockConsumer>
        {(value) => (
          <Component
            {...componentProps}
            capsLockOn={value} />
        )}
      </CapsLockConsumer>
    );
    
    wrapper.displayName = 'withCapsLockListener(' + Component.displayName + ')';
    wrapper.WrappedComponent = Component;
    
    wrapper.propTypes = Component.propTypes;
    
    return wrapper;
  }
  return null;
};
